export function createSrcSet(data: Record<string, string>) {
  return Object.entries(data)
    .map(([key, value]) => (key ? [value, key].join(' ') : value))
    .join(', ')
}
